require('./bootstrap');
require('./global');
require('./utils');
require('./sistema/admin/users');
require('./sistema/admin/permissions');
require('./sistema/admin/role_has_permissions');
require('./sistema/admin/roles');
require('./sistema/admin/customers');
require('./sistema/wallets');
require('./sistema/agencies');
require('./sistema/report_branch_office');
require('./sistema/report-campaign');
require('./sistema/report-consented-client');

require('./sistema_local/tickets');
require('./sistema_local/exchangeBalance');
require('./sistema_local/campaigns');
require('./sistema_local/campaign-branchOffices');
require('./sistema_local/campaign_articles');
require('./sistema_local/campaign_porcentajes');
require('./sistema/premier-customer');


/*Fix para menú hamburguesa y dropdowns. También ser requiere el codigo en resources/views/vendor/adminlte/pages.blade.php línea 60*/
document.addEventListener('DOMContentLoaded', function() {
    // 👇 FIX hamburguesa con AdminLTE
    document.querySelectorAll('[data-widget="pushmenu"]').forEach(button => {
        button.addEventListener('click', e => {
            e.preventDefault();
            document.body.classList.toggle('sidebar-collapse');
        });
    });

    // 👇 FIX cerrar session
    document.querySelectorAll('.nav-item.dropdown.user-menu > .dropdown-toggle').forEach(toggle => {
        toggle.addEventListener('click', e => {
            e.preventDefault();

            const parent = e.target.closest('.dropdown');
            const menu = parent.querySelector('.dropdown-menu');

            // Cerrar otros dropdowns
            document.querySelectorAll('.nav-item.dropdown.user-menu.show').forEach(openMenu => {
                if (openMenu !== parent) {
                    openMenu.classList.remove('show');
                    openMenu.querySelector('.dropdown-menu')?.classList.remove('show');
                }
            });

            parent.classList.toggle('show');
            menu.classList.toggle('show');
        });
    });
});

